import { useMemo } from 'react';
import { Box, Container, Typography, Stack, IconButton, useTheme } from '@mui/material';
import { useGetSettingsByCodes } from '@/services/queries/useSettingQuery';
import { SettingsCodes } from '@/enums/enums';
import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon } from '@/assets/icons';

const backgroundImageUrl = '/assets/images/footer-red.svg';

const codes: string[] = [
  SettingsCodes.FBLINK,
  SettingsCodes.INSTA,
  SettingsCodes.YOUTBE,
  SettingsCodes.TWTER,
];

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const { data } = useGetSettingsByCodes(codes.join(','));

  const dataWithIcon = useMemo(() => {
    return data?.map((setting) => {
      if (setting.code === SettingsCodes.FBLINK) {
        return { ...setting, icon: <FacebookIcon /> };
      }
      if (setting.code === SettingsCodes.INSTA) {
        return { ...setting, icon: <InstagramIcon /> };
      }
      if (setting.code === SettingsCodes.YOUTBE) {
        return { ...setting, icon: <YoutubeIcon /> };
      }
      if (setting.code === SettingsCodes.TWTER) {
        return { ...setting, icon: <TwitterIcon /> };
      }
    });
  }, [data]);

  return (
    <Box >
      {/* Social Links - Right side (Start in RTL) */}
      <Box
        sx={{
          display: 'flex',
          background: `url(${backgroundImageUrl}) lightgray 50% / cover no-repeat`,
          py: 3,
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          mt: 'auto',
          px: '1.45rem',
          height: '6.9375rem',
        }}
      >
        <Stack
          direction='row'
          spacing={2}
          sx={{
            alignItems: 'center',
            order: { xs: 2, md: 1 }, // On desktop, this is 1st (Right/Start). On mobile, 2nd (Top)
          }}
        >
          <Typography
            variant='body1'
            sx={{
              fontWeight: 500,
              fontSize: '1rem',
            }}
          >
            تابعونا
          </Typography>
          <Stack direction='row-reverse' spacing={1}>
            {dataWithIcon?.map((setting) => (
              <IconButton
                key={`${setting?.id}-social-media`}
                sx={{
                  color: 'white',
                  borderRadius: '50%',
                  border: '1px solid white',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                }}
                target='_blank'
                rel='noopener noreferrer'
                href={setting?.value ?? ''}
              >
                {setting?.icon}
              </IconButton>
            ))}
          </Stack>
        </Stack>
      </Box>
      <Box sx={{ bgcolor: theme.palette.custom.blue.dark, py: 3, color: 'white', mt: 'auto', px: '1.45rem' }}>
        <Container maxWidth={false}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: { xs: 'column-reverse', md: 'row' }, // Stack vertically on mobile
              gap: 2,
            }}
          >
            {/* Copyright - Left side (End in RTL) */}
            <Typography
              variant='body1'
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                order: { xs: 1, md: 2 }, // On desktop, this is 2nd (Left/End). On mobile, 1st (Bottom)
              }}
            >
              جميع الحقوق محفوظة {currentYear} ©
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;